module.exports = __webpack_public_path__ + "static/media/fictional.bb88663f.png";